import React , { Component } from 'react';
import $ from 'jquery';
import { Link, browserHistory } from 'react-router';
import ReactStars from 'react-stars';
// import Switch from './switch.js';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class View_Rating extends Component{
	constructor(props){
		super(props);
		this.state={
			over_rate:'',
			pack_rate:'',
			recomend:'',
			seller:'',
			book_date:'',
			nodata_status:false,
		}
		this.getSeedDetails=this.getSeedDetails.bind(this);
		this.getProductDetails=this.getProductDetails.bind(this);
		this.handleChange=this.handleChange.bind(this);

		this.over_rateChanged=this.over_rateChanged.bind(this);
		this.seed_rateChanged=this.seed_rateChanged.bind(this);
		this.serv_rateChanged=this.serv_rateChanged.bind(this);
		this.pack_rateChanged=this.pack_rateChanged.bind(this);
	}
	componentDidMount()
	{
		if(screen.width >= 800)
		{
			if(this.props.params.Product==='product')
			{
				window.location.href='/web/viewrating/'+this.props.params.Product+'/'+this.props.params.Bid;
			}
			else
			{
				window.location.href="/web/viewrating/"+this.props.params.Bid;
			}
		}
		if(this.props.params.Product==='product')
		{
			this.getProductDetails();
		}
		else
		{
			this.getSeedDetails();
		}
		if(!localStorage.token && !localStorage.user_id)
		{
			if(this.props.params.Product==='product')
			{
				localStorage.setItem('view_rating','/viewrating/'+this.props.params.Product+'/'+this.props.params.Bid)
				browserHistory.push('/login');	
			}
			else
			{
				localStorage.setItem('view_rating','/viewrating/'+this.props.params.Bid);
				browserHistory.push('/login');
			}
		}
	}
	getSeedDetails()
	{
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,bid:this.props.params.Bid};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'getrating',
			data:{req:data2},
			success:function(data)
			{
				this.setState({
					seed_rate:data.seed_rate,
					serv_rate:data.serv_rate,
					pack_rate:data.pack_rate,
					over_rate:data.over_rate,
					recomend:data.recomend,
					seller:data.seller,
					book_date:data.book_date,
				});
				if(data.status==='fails')
				{
					this.setState({
						nodata_status: true,
					});
				}
			}.bind(this),
			error:function(err)
			{
				console.log(err);
			}
		});
	}
	getProductDetails()
	{
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,bid:this.props.params.Bid};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'getpro_book_rating',
			data:{req:data2},
			success:function(data)
			{
				this.setState({
					seed_rate:data.product_rate,
					serv_rate:data.serv_rate,
					pack_rate:data.pack_rate,
					over_rate:data.over_rate,
					recomend:data.recomend,
					seller:data.seller,
					book_date:data.book_date,
				});
				if(data.status==='fails')
				{
					this.setState({
						nodata_status: true,
					});
				}
			}.bind(this),
			error:function(err)
			{
				console.log(err);
			}
		});
	}
	ratingChanged(newRating){
  		//console.log(newRating)
	}
	handleChange ()
	{
		this.setState({
			recomend: !this.state.recomend
		});
    }
    over_rateChanged(newRating)
	{
		console.log(newRating);
		this.setState({
			over_rate:newRating,
		});
	}
	seed_rateChanged(newRating)
	{
		console.log(newRating);
		this.setState({
			seed_rate:newRating,
		});
	}
	serv_rateChanged(newRating)
	{
		console.log(newRating);
		this.setState({
			serv_rate:newRating,
		});
	}
	pack_rateChanged(newRating)
	{
		console.log(newRating);
		this.setState({
			pack_rate:newRating,
		});
	}
	render(){
		document.title=this.props.params.Product ==='product' ? 'View Product Ratings | AquaDeals' : 'View Hatchery Ratings | AquaDeals';
		$('body').css('background','#f1f1f2');

		var switch_btn =this.state.recomend ? <div className="switch-container custom_switch_blk">
			                <label>
			                    <input ref="switch" checked={this.state.recomend ==="true" ? true : false} disabled onChange={this.handleChange} className="switch" type="checkbox" />
			                    <div>
			                        <span><g className="icon icon-toolbar grid-view"></g></span>
			                        <span><g className="icon icon-toolbar ticket-view"></g></span>
			                        <div></div>
			                    </div>
			                </label>
			            </div> : '';

		var pack_rate =<ReactStars
		 				  className={'rate_dtls_item'}
						  count={5}
						  onChange={this.pack_rateChanged}
						  size={20}
						  edit={false}
						  value={this.state.pack_rate}
						  color1={'#F3F3F3'}
						  color2={'#FABB9A'} />;

		var seed_rate=<ReactStars
						  className={'rate_dtls_item'}
						  count={5}
						  onChange={this.seed_rateChanged}
						  size={20}
						  edit={false}
						  value={this.state.seed_rate}
						  color1={'#F3F3F3'}
						  color2={'#FABB9A'} />;

		var serv_rate=<ReactStars
						  className={'rate_dtls_item'}
						  count={5}
						  onChange={this.serv_rateChanged}
						  size={20}
						  edit={false}
						  value={this.state.serv_rate}
						  color1={'#F3F3F3'}
						  color2={'#FABB9A'} />;
		var over_rate=<ReactStars
						  className={'rate_dtls_item'}
						  count={5}
						  onChange={this.over_rateChanged}
						  size={20}
						  edit={false}
						  value={this.state.over_rate}
						  color1={'#F3F3F3'}
						  color2={'#FABB9A'} />;		  
		return(
			<div className="mob_deals rate_details_page">
				<div className="page_hdr">
					<div className="container-fluid">
						<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>{this.props.params.Product ==='product' ? 'View Product Ratings' : 'View Hatchery Ratings'}</h5>
						<a href="/" title="Home" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
				    </div>
				</div>
				<div className="pag_cntnt">&nbsp;</div>
				{this.state.nodata_status ? <section><div style={{textAlign:'center',marginTop:'150px'}}>Rating Not Available</div></section> : 
				<div>
				<section className="">
					<div className="from_dtls_blk">
						<p>FROM</p>
						{this.state.seller ? <p>{this.state.seller}</p> : <p>&nbsp;</p>}
						<p>ORDER DATE</p>
						{this.state.book_date ? <p>{this.state.book_date}</p> : <p>&nbsp;</p>}
					</div>
				</section>
				<section style={{marginTop:'10px',fontSize:'12px'}}>
					<div className="rating_list_blk">
						<div className="rating_list_item">
							<span style={{float:'left'}}>Overall Rating</span>
							{over_rate}
						</div>
						<div className="rating_list_item">
							<span style={{float:'left'}}>Service Quality</span>
							{serv_rate}
						</div>
						<div className="rating_list_item">
							<span style={{float:'left'}}>{this.props.params.Product==='product' ? 'Product Quality' :  'Seed Quality' }</span>
							{seed_rate}
						</div>
						<div className="rating_list_item">
							<span style={{float:'left'}}>Packing Quality</span>
							{pack_rate}
						</div>
					</div>
				</section>
				<section style={{marginTop:'10px',}}>
					{this.state.recomend === true ? <div className="rate_rec_blk"><span style={{width:'75%',display:'block'}}>{this.props.params.Product ==='product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'}</span><span>{this.state.recomend ? switch_btn : ''}</span></div> : <div className="rate_rec_blk"><span style={{width:'75%',display:'block'}}>{this.props.params.Product ==='product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'}</span><span>{this.state.recomend ? switch_btn : ''}</span></div>}
				</section>
				</div> }
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Accounts/View_Rating.js
 **/